import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Button, Col, Divider, Modal, notification, Row, Table } from 'antd'
import React, { useState } from 'react'
import { DeleteOutlined, ProfileOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { deleteArticle, getArticles } from '../../services/api';

const Home = () => {
  const queryClient = useQueryClient();
  const [ ntf, contextHolder ] = notification.useNotification();
  const {data} = useQuery({ queryKey: ['todos'], queryFn: getArticles });
  const {mutate: mutateDeleteArticle, isSuccess} = useMutation(deleteArticle)
  const [isOpenDeleteArticleModal, setisOpenDeleteArticleModal] = useState({open: false, id: 0});

  const handleDelete = () => {
    console.log(isOpenDeleteArticleModal.id)
    mutateDeleteArticle({id: isOpenDeleteArticleModal.id}, {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(['todos']);
        setisOpenDeleteArticleModal({open: false, id: 0});
        ntf.success({
          message: `Success`,
          description: "Blog is deleted with success!",
          placement: "bottomLeft",
        });
      },
      onError(error, variables, context) {
        ntf.error({
          message: `Error`,
          description: "Something gonne wrong!",
          placement: "bottomLeft",
        });
      },
    })
  }

  const columns: any = [
    {
      title: 'Blog Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (title: string, record: any) => <Link to={`/blogs/${record.id}`}>{title}</Link>
    },
    {
      title: 'Date Added',
      dataIndex: 'date_added',
      key: 'date_added'
    },
    {
      title: 'Delete',
      dataIndex: 'delete',
      key: 'delete',
      align: 'center',
      width: '50px',
      render: (id: any, record: any) => <Button icon={<DeleteOutlined />} danger onClick={() => setisOpenDeleteArticleModal({open: true, id: record.id})} />
    },
  ];
  

  return (
    <Row justify="center">
      {contextHolder}
      <Divider plain>
        <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
          <ProfileOutlined style={{ fontSize: '24px', color: '#42A5F5' }} />
          <h1>Blogs</h1>
        </div>
      </Divider>
      <Col span={20}></Col>
      <Col span={20}>
        <Table dataSource={data} columns={columns} />;
      </Col>
      <Modal title="Delete Blog?" open={isOpenDeleteArticleModal.open} onOk={() => handleDelete()} onCancel={() => setisOpenDeleteArticleModal({open: false, id: 0})}>
        Do you really want to delete it?
      </Modal>
    </Row>
  )
}

export default Home